import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Login from "../components/loginbutton"

function SignIn() {
  const [planID, setPlanId] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Set the visibility to true after a short delay to trigger the transition
    setTimeout(() => {
      setVisible(true);
    }, 100);
  }, []);

  const handleChange = (event) => {
    setPlanId(event.target.value);
  };

  return (
    <div className={`flex items-center justify-center h-screen bg-[#121212] text-white `}>
      <Login>
        
      </Login>
    </div>
  );
}

export default SignIn;
